import { Children, isValidElement, ReactNode, useEffect } from "react";
import cn from "classnames";
import { TabsRow } from "./TabsRow";
import styles from "./Tabs.module.scss";

import { useTabsContext } from "./Tabs.context";

interface ITabsBodyProps {
  className?: string;
}

const getFirstChildDataTabAttribute = (children: React.ReactNode) => {
  const firstChild = Children.toArray(children).find((child) => isValidElement(child) && child.props["data-tab"])!;
  if (!isValidElement(firstChild)) return "";
  return firstChild.props["data-tab"];
};

const resolveInitialPanel = (children: ReactNode | ReactNode[]) => {
  return Array.isArray(children) ? children[0] : children;
};

export const TabsBody: RFC<ITabsBodyProps> = ({ className, children }) => {
  const { activeTabId, setActiveTabId } = useTabsContext();

  useEffect(() => {
    if (activeTabId === "") {
      setActiveTabId(getFirstChildDataTabAttribute(children));
    }
  }, []);

  const activePanel = Children.toArray(children)
    .filter(Boolean)
    .find((child) => isValidElement(child) && child.props["data-tab"] === activeTabId);

  const kids = activePanel ? activePanel : resolveInitialPanel(children);

  return <TabsRow className={cn(styles.body, className)}>{kids}</TabsRow>;
};

TabsBody.displayName = "TabsBody";
